import styled from 'styled-components';

import { ControlContainer } from '../../base/Control';
import { RadioButtonProps } from './types';
import { Button } from '../Button';

export const RadioButtonContainer = styled(ControlContainer)<RadioButtonProps>`
  input:checked + ${Button} {
    background-color: ${({ theme }) => theme.mosaiq.colors.grey};
    border-color: ${({ theme }) => theme.mosaiq.colors.black};
  }
`;
